import { SxProps, Theme } from '@mui/material';

export const lowerFooterContainerSx: SxProps<Theme> = (theme: Theme) => ({
	display: 'flex',
	alignItems: 'center',
	[theme.breakpoints.down('lg')]: {
		flexDirection: 'column',
		gap: '10px',
	},
	[theme.breakpoints.up('lg')]: {
		flexDirection: 'row',
		justifyContent: 'left',
		gap: '20px',
	},

	'&__container': {
		display: 'flex',
		justifyContent: 'left',
		alignItems: 'center',
		marginBottom: 0,

		'@media screen and (max-width: 1439px)': {
			flexDirection: 'column',
			marginBottom: '20px',
		},

		'.MuiTypography-root': {
			'@media screen and (max-width:  960px)': {
				marginBottom: 0,
			},
		},

		'&-icons': {
			display: 'flex',
			alignItems: 'center',
			width: '100%',
			justifyContent: 'center',
			maxWidth: '300px',
			img: {
				width: '24px',
			},
			divLastChild: {
				marginRight: '0px',
			},
			'@media screen and (max-width: 1439px)': {
				div: {
					marginTop: '10px',
				},
			},

			'@media screen and (max-width:  960px)': {
				justifyContent: 'center',
				width: '60%',
			},

			div: {
				marginRight: '15px',
				backgroundColor: '#FD8331',
				display: 'flex',
				justifyContent: 'left',
				alignItems: 'center',
				padding: '3px',
				color: 'white',

				a: {
					margin: 0,
					color: 'white',
					textDecoration: 'none',
					width: '24px',
					height: '24px',

					svg: {
						color: 'white',
						width: '100%',
						height: '100%',
					},
				},
			},
		},
	},
});
